import { render, staticRenderFns } from "./BaseTutorialModal.vue?vue&type=template&id=3a71f03a&scoped=true"
import script from "./BaseTutorialModal.vue?vue&type=script&lang=js"
export * from "./BaseTutorialModal.vue?vue&type=script&lang=js"
import style0 from "./BaseTutorialModal.vue?vue&type=style&index=0&id=3a71f03a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a71f03a",
  null
  
)

export default component.exports